import { useEffect } from 'react';
import Image from 'next/image';
import gsap from 'gsap';

const AnimCard6 = () => {
  useEffect(() => {
    gsap.context(() => {
      gsap
        .timeline({
          repeat: -1
        })
        .fromTo(
          '.anim-card-6-box-js',
          {
            autoAlpha: 0,
            y: -20
          },
          {
            autoAlpha: 1,
            y: 0,
            ease: 'bounce.out',
            stagger: 0.5
          }
        )
        .fromTo(
          '.anim-card-6-shield-js',
          {
            autoAlpha: 0,
            scale: 1.1
          },
          {
            autoAlpha: 1,
            scale: 1,
            ease: 'expo.out'
          }
        )
        .fromTo(
          '.anim-card-6-check-js',
          {
            clipPath: 'inset(0% 100% 0% 0%)'
          },
          {
            clipPath: 'inset(0% 0% 0% 0%)',
            ease: 'power2.out'
          }
        )
        .to('.anim-card-6-shield-js', {
          y: 1,
          duration: 2
        });
    });
  }, []);

  return (
    <>
      <div className="absolute inset-0">
        <Image
          src="/images/animcards/6/cart.svg"
          width={228}
          height={193}
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute bottom-[15%] left-[20%] | anim-card-6-box-js">
        <Image
          src="/images/animcards/6/box1.svg"
          width={69}
          height={51}
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute bottom-[41%] left-[23%] | anim-card-6-box-js">
        <Image
          src="/images/animcards/6/box2.svg"
          width={57}
          height={51}
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute top-[26%] right-[29%] anim-card-6-shield-js">
        <div className="relative w-68 h-80">
          <Image
            src="/images/animcards/6/shield.svg"
            width={68}
            height={80}
            alt=""
            className="w-full h-full object-cover"
          />
          <div className="absolute top-[48%] left-1/2 -translate-y-1/2 -translate-x-1/2 | anim-card-6-check-js">
            <svg
              width="26"
              height="21"
              viewBox="0 0 26 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 11.7391L8.27273 20L25 1"
                stroke="white"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>
      </div>
    </>
  );
};
export default AnimCard6;
